import 'vite/modulepreload-polyfill'
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import './photoswipe.css';
import PhotoSwipe from "photoswipe";

const defaultOptions = {
    bgOpacity: 1,
    loop: false,
    preloaderDelay: 100,
    padding: {
        top: 50,
        bottom: 50,
        left: 0,
        right: 0
    },
    pswpModule: PhotoSwipe
};

window.configurePhotoswipe = function (options = {}) {
    const lightbox = new PhotoSwipeLightbox({...defaultOptions, ...options});
    lightbox.on('uiRegister', function () {
        lightbox.pswp.ui.registerElement({
            name: 'caption',
            order: 9,
            isButton: false,
            appendTo: 'root',
            onInit: (el, pswp) => {
                lightbox.pswp.on('change', () => {
                    el.innerHTML = lightbox.pswp.currSlide.data.alt;
                });
            }
        });
    });

    lightbox.init();
    return lightbox;
}
